"use client"

import { useContext } from "react"
import ConfigurationContext from "../context/ConfigurationContext.js"
import useBranding from "../hook/UseBranding.js"
import useLocation from "../hook/UseLocation.js"
import Translation from "../i18n/Translation.js"
import { FaceSignatureCompletionQueryParametersSchema } from "../schemata/biometry/FaceSignatureCompletionQueryParameters.js"
import Validate from "../support/language/Validate.js"
import BrandedThemeProvider from "./BrandedThemeProvider.js"
import VerificationCompletion from "./VerificationCompletion.js"

type Properties = Readonly<{}>

/**
 * @description
 *	The default landing for Face Signature redirection.
 */
export default function FaceSignatureRedirect({}: Properties) {
	const configuration = useContext(ConfigurationContext)
	const uri = useLocation()
	const queryParameters = Validate(FaceSignatureCompletionQueryParametersSchema, {
		integrationId: uri?.queryParameters.get("integrationId") || undefined,
		isLive: uri?.queryParameters.get("isLive"),
		status: uri?.queryParameters.get("status")
	})
	const { branding, settled } = useBranding(queryParameters?.integrationId)
	return (
		<BrandedThemeProvider branding={branding} isBrandingSettled={settled}>
			{queryParameters && (
				<VerificationCompletion
					branding={branding}
					completionText={Translation[configuration.DEFAULT_LOCALE].faceSignatureCompletion!}
					isLive={queryParameters.isLive}
					status={queryParameters.status}
				/>
			)}
		</BrandedThemeProvider>
	)
}
